<template>
  <ul class="mockup-preview-stores">
    <li
      class="mockup-preview-stores__item"
      :class="{ 'mockup-preview-stores__item--active': includes(store) }"
      v-for="(store, i) in stores"
      :key="i"
      @click="clickStore(store)"
    >
      {{ store }}
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    current: Object,
  },
  data() {
    return {
      stores: ["br", "global"],
    };
  },
  methods: {
    clickStore(store) {
      if (this.includes(store))
        this.current.stores = this.current.stores.filter((s) => s !== store);
      else this.current.stores.push(store);
    },
    includes(store) {
      return this.current.stores.includes(store);
    },
  },
};
</script>

<style lang="scss" scoped>
.mockup-preview-stores {
  margin: 6px 0 0;
  padding: 0;
  list-style: none;
  border: 1px solid #f2f2f4;
  height: 45px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #888;
  border-radius: 5px;
  overflow: hidden;

  &__item {
    line-height: 45px;
    padding: 0 6px;
    flex: 1;
    cursor: pointer;

    &:hover {
      opacity: 0.5;
    }

    &--active {
      background-color: #ec8ab3;
      color: #fff;
    }
  }
}
</style>
